<template>
    <slot></slot>
</template>

<script lang="ts" setup>
import { getWindow } from '@/helpers/globals'
import { nextTick, onMounted, watch } from 'vue'

const props = defineProps<{
    refreshKey: string | number | null
}>()

const affirmSDK = getWindow()?.affirm

if (affirmSDK) {
    const refresh = () => {
        affirmSDK.ui?.refresh?.()
    }

    onMounted(refresh)

    watch(
        () => props.refreshKey,
        () => {
            nextTick(refresh)
        }
    )
}
</script>
